import React, { Suspense, useState } from 'react';
import { Grid, GridItem } from 'components/UI/Grid';
import { useInsightsVideo } from 'staticQueries/insights-video';
import VideoCard from './VideoCard';
import PlayerModal from 'components/Modals/PlayerModal';
import { useStateModal } from 'utils/hooks';

export default function PinnedContent({ items, isThemeDark }) {
  const videoIdArray = items?.filter(({ type }) => type === 'video').map(({ id }) => id);
  const videos = useInsightsVideo(videoIdArray)?.slice(0, 2);

  const { modalState, showModal, hideModal } = useStateModal();
  const [videoSrc, setVideoSrc] = useState(null);

  const gridSettings = {
    xsm: { cols: 1, gutterX: '20px', gutterY: '40px' },
    sm: { cols: 2, gutterX: '20px', gutterY: '40px' },
    md: { cols: 2, gutterX: '30px', gutterY: '40px' },
    lg: { cols: 2, gutterX: '30px', gutterY: '40px' },
    xl: { cols: 2, gutterX: '40px', gutterY: '40px' },
  };

  const openModal = videoId => {
    setVideoSrc(videoId);
    showModal();
  };

  return (
    <section>
      <Grid {...gridSettings}>
        {videos.map((item, i) => (
          <GridItem key={`card-${i}`}>
            <VideoCard
              {...item}
              cover={item.cover}
              openModal={() => openModal(item.videoId)}
              isThemeDark={isThemeDark}
            />
          </GridItem>
        ))}
      </Grid>
      <Suspense fallback={null}>
        <PlayerModal
          isOpen={modalState.isOpen}
          closeModalCallback={hideModal}
          data={{ videoSrc }}
        />
      </Suspense>
    </section>
  );
}
